import React, { Component } from 'react'
import { connect } from 'react-redux'

import { ENDPOINT_REQUEST } from "@/configurations";
import { stockActions } from '@/actions/trading/stock.action'
import { stockServices } from '@/services/trading-services/stock.services'

import '@/assets/styles/components/market/market-index.scss'

class MarketIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      titles: props.data,
    }
    this.resources = Promise.all([
      import('@/assets/ttl_chart_lib/vendor.1d4c06ac'),
      import('@/assets/ttl_chart_lib/TTLStockChart_MobileApp.ba94aa5b'), 
      import('@/assets/ttl_chart_lib/TTLStockChart_MobileApp.3e89e081.css'),
    ])
    this.charts = Array(props.data.length).fill()
    this.getIndexData = this.getIndexData.bind(this)
    this.renderCharts = this.renderCharts.bind(this)
    props.innerRef && props.innerRef(this)
  }

  onChangeChartLayout = () => {
    const { theme, isMobile } = this.props;
    this.charts.forEach(item => {
      if (item) {
        item.changeLayout(theme.charAt(0).toUpperCase() + theme.slice(1), isMobile);
      }
    })
  }

  renderCharts() {
    const { data, mdsToken, theme, isMobile } = this.props
    this.resources.then(() => {
      setTimeout(() => {
        data.forEach((item, index) => {
          const chartRef = new TTLStockChart(`market_index_chart_${item.key}`, ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, stockServices.enquireInstrumentInfo)
          chartRef.drawChart()
          chartRef.setWSSessionID(mdsToken)
          chartRef.setSymbol(item)
          chartRef.importState(['Line', [], []])
          chartRef.showChartControl(false);
          chartRef.showChartDataControl(false);
          chartRef.showOHCLTooltip(false);
          chartRef.setTimeLineHeight(-1);
          chartRef.setChartHeight(130);
          chartRef.setSimpleMode(false);
          chartRef.setIsEnabledCrosshair(true);
          chartRef.setHoverTooltipConfig(true);
          chartRef.changeLayout(theme.charAt(0).toUpperCase() + theme.slice(1), isMobile);
          this.charts[index] = chartRef
        })
      }, 500)
    })
  }

  getIndexData() {
    const { data } = this.props
    stockActions.getIndexDataAction({ symbols: data }, res => {
      if (res.rtnCode) return

      data.forEach((item, index) => {
        if (res.code === item.key) {
          const titles = JSON.parse(JSON.stringify(this.state.titles))
          titles[index].data = res
          this.setState({ titles })
        }
      })
    })
  }

  getLanguageName(item) {
    const { language } = this.props
    if (item.data && item.data.code) {
      switch (language.lang) {
        case 'zh_CN':
          return item.data.scName
        case 'zh_TW':
          return item.data.tcName
        case 'en_US':
          if (isNaN(item.data.code)) {
            return item.data.code
          } else {
            return [item.exchangeID, item.key].join(' ')
          }
        default:
          return item.data.code
      }
    }
    if (isNaN(item.key)) {
      return item.key
    } else {
      return [item.exchangeID, item.key].join(' ')
    }
  }

  getClassStyle(item) {
    return item > 0 ? 'rise-color' : (item < 0 ? 'fall-color' : 'default-color')
  }

  getPositiveSign(item) {
    return item > 0 ? `+${item}` : item
  }

  updateCharts() {
    const { data } = this.props
    this.getIndexData()
    data.forEach((item, index) => {
      this.charts[index].setSymbol(item)
    })
  }

  componentDidMount() {
    this.getIndexData()
    this.renderCharts()
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme !== prevProps.theme) {
      this.onChangeChartLayout();
    }
  }

  render() {
    const { data } = this.props
    const { titles } = this.state
    return (
      <div className='market_index_charts'>
        <div className='market_index_scroll_wrapper'>
          {titles.map((item, index) => {
            return (
              <div className='market_index_chart' key={index}>
                <div className='market_index_title'>
                  <span className='market_index_name'>{this.getLanguageName(item)}</span>
                  {item.data && (
                    <span className={this.getClassStyle(item.data.netChgPrevDay)}>
                      <span className='market_index_value'>{item.data.value}</span>
                      <span className='market_index_netChgPrevDay'>{item.data.netChgPrevDay}</span>
                      <span className='market_index_netChgPrevDatPct'>({this.getPositiveSign(item.data.netChgPrevDatPct)})</span>
                    </span>
                  )}
                </div>
                <div className='market_index_chart_ref' id={`market_index_chart_${data[index].key}`}></div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

MarketIndex.defaultProps = {
  data: [],
  innerRef: () => {}
}

export default connect(
  state => ({
    language: state.app.language,
    mdsToken: state.trade.mdsToken,
    theme: state.app.theme,
    isMobile: state.app.isMobile,
  }),
  dispatch => ({})
)(MarketIndex)
